import React from 'react';
import { withStyles, Typography, Paper, Switch, InputLabel, IconButton, Slide } from '@material-ui/core';
import Slider from '@material-ui/lab/Slider';
import ParametroService from '../../../services/ParametroService';
import ChevronLeft from '@material-ui/icons/ChevronLeft';
import { Link } from 'react-router-dom';
import VariantSnackbar from '../../share/VariantSnackbar';

const styles = theme => ({
  root: {
    ...theme.mixins.gutters(),
    paddingTop: theme.spacing.unit * 2,
    paddingBottom: theme.spacing.unit * 2,
    marginTop: theme.spacing.unit * 2,
    marginBottom: theme.spacing.unit,
    display: 'flex',
    verticalAlign: 'middle',
  },
  paper: {
    verticalAlign: 'middle',
    display: 'block',
  },
  typography: {
    paddingTop: theme.spacing.unit,
  },
  typographySwitch: {
    paddingTop: theme.spacing.unit * 2,
  },
  typographySlider: {
    marginLeft: theme.spacing.unit * 6,
  },
  slider: {
    width: 300,
    display: 'flex',
    marginLeft: theme.spacing.unit * 2,
    paddingTop: theme.spacing.unit,
  },
  link: {
    textDecoration: 'none',
  },
  titlebar: {
    display: 'flex',
    alignItems: 'center',
  },
});

const PARAM_EXISTEM_RECURSOS = 6;
const PARAM_PERCENTUAL_LIMITE = 23;

class Parametros extends React.Component {
  parametroService = new ParametroService();
  state = {
    existemRecursos: false,
    percentualLimite: 0,
    snackOpen: false,
  };

  componentDidMount () {
    this.consultarParametro(PARAM_EXISTEM_RECURSOS, PARAM_PERCENTUAL_LIMITE);
  }

  consultarParametro = async (codParametroExistemRecursos, codParametroPercentualLimite) => {
    const valorParametroExistemRecursos = await this.parametroService.consultarParametro(codParametroExistemRecursos);
    const valorParametroPercentualLimite = await this.parametroService.consultarParametro(codParametroPercentualLimite);
    this.setState({ existemRecursos: Boolean(valorParametroExistemRecursos), percentualLimite: Number(valorParametroPercentualLimite) });
  }

  handleChangeSwitch = event => {
    const valor = event.target.checked;
    this.parametroService.updateParametro(PARAM_EXISTEM_RECURSOS, valor ? 1 : 0);
    this.setState({ existemRecursos: valor, snackOpen: true });
  };

  handleChangeRange = (event, value) => {
    this.setState({ percentualLimite: value });
  };

  handleSavePercentual = async event => {
    const valor = this.state.percentualLimite;
    await this.parametroService.updateParametro(PARAM_PERCENTUAL_LIMITE, valor);
    this.setState({snackOpen: true});
  };

  handleCloseSnackbar = () => {
    this.setState({ snackOpen: false });
  };

  render () {
    const { classes } = this.props;
    const { existemRecursos, percentualLimite } = this.state;
    return (
      <React.Fragment>
        <Link to='/tabelasApoio' className={classes.link}>
          <Slide direction='down' timeout={600} in>
            <Paper elevation={1} className={classes.titlebar}>
              <IconButton color='inherit' aria-label='Close'>
                <ChevronLeft />
              </IconButton>
              <Typography variant='headline'>Parâmetros do Sistema</Typography>
            </Paper>
          </Slide>
        </Link>
        <Paper className={classes.root} elevation={1}>
          <Typography className={classes.typographySwitch}>
            Existem Recursos no Orçamento da União para Pagamento de Demonstrativos?
          </Typography>
          <Switch
            checked={existemRecursos}
            onChange={this.handleChangeSwitch}
            value='existemRecursos'
            color='primary'
          />
        </Paper>
        <Paper className={classes.root} elevation={1}>
          <Typography className={classes.typography}>
            Percentual Limite do Orçamento da União para Emissão de Demonstrativos:
          </Typography>
          <div className={classes.slider}>
            <Typography>
              {percentualLimite.toString().concat('%')}
            </Typography>
            <InputLabel shrink className={classes.typographySlider}>0</InputLabel>
            <Slider
              value={percentualLimite}
              step={1}
              onChange={this.handleChangeRange}
              onDragEnd={this.handleSavePercentual}
            />
            <InputLabel shrink>100</InputLabel>
          </div>
        </Paper>
        <VariantSnackbar
          vertical={'top'}
          horizontal={'right'}
          variant={'success'}
          message={'Parâmetro alterado com sucesso!'}
          open={this.state.snackOpen}
          handleClose={this.handleCloseSnackbar} />

      </React.Fragment>
    );
  }
}
export default withStyles(styles)(Parametros);
